import { useMemo } from "react";
import { SelectionFeature } from "src/js/stores/map/store";
import { buildConstraintsTileUrl } from "react-migration/domains/constraints/components/ConstraintLayer/ConstraintLayer";
import { StaticMapWithSelection } from "react-migration/domains/sites/card/Map/renderers/StaticMapReact";
import { DesignationLayer } from "react-migration/domains/constraints/components/ConstraintLayer/DesignationLayer";
import { useConstraintsLayerTypeContext } from "../ConstraintsContext";
import { tileDesignationIsVisible } from "../ConstraintsContext/utils";
import { ConstraintLayerConfig, isSingleConstraintLayer } from "../types";
import { ConstraintsCategory } from "react-migration/layouts/map/Constraints/types";

interface PrintableMapLayerProps {
  id: string;
  selection: SelectionFeature;
  layerConfig: ConstraintLayerConfig;
  onLoaded: (error?: string) => void;
}

export function PrintableMapLayer({ layerConfig, id, selection, onLoaded }: PrintableMapLayerProps) {
  const { constraintsStore } = useConstraintsLayerTypeContext();
  const layerState = constraintsStore.layers[id];

  const mapLayers = useMemo(() => {
    if (!layerState.visibleCategories.length) return;

    const rootCategories: ConstraintsCategory[] = isSingleConstraintLayer(layerConfig)
      ? [layerConfig.rootCategory]
      : layerConfig.rootCategories;

    return rootCategories.map(
      (rootCategory) =>
        new DesignationLayer({
          id: id,
          data: buildConstraintsTileUrl({
            rootCategory,
            designationAttributes: layerConfig.attributesToLoad,
            dedupePoints: layerConfig.dedupePoints,
            filterAreaByZoom: layerConfig.filterAreaByZoom,
            simplifyProfile: layerConfig.simplifyProfile,
          }),
          featureIsVisible: (designation) => tileDesignationIsVisible(designation, layerState),
        })
    );
  }, [id, layerConfig, layerState]);

  return <StaticMapWithSelection id={id} layers={mapLayers} onReady={onLoaded} selection={selection} />;
}
